import styled from "styled-components";

export const GameProducer = styled.div`
  justify-content: flex-end;
  display: flex;
  flex: 1 1 45%;
  overflow: hidden;
  white-space: nowrap;
  margin: 0 0 0 1em;

  @media (orientation: portrait) {
    text-align: right;
  }
`;
